import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from '@app/modules/auth/layout/auth-layout.component';
import { LoginPageComponent } from '@app/modules/auth/page/login/login.component';
import { RegistrationPageComponent } from '@app/modules/auth/page/registration/registration.component';
import { PasswordRestorePageComponent } from '@app/modules/auth/page/password-restore/password-restore.component';
import { RegistrationConfirmPageComponent } from '@app/modules/auth/page/registration-confirm/registration-confirm.component';
import { RegistrationWithpinConfirmPageComponent } from '@app/modules/auth/page/registration-withpin-confirm/registration-withpin-confirm.component';
import { SelectRolePageComponent } from '@app/modules/auth/page/select-role/select-role.component';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      { path: 'login', component: LoginPageComponent },
      { path: 'select-role', component: SelectRolePageComponent },
      { path: 'registration', component: RegistrationPageComponent },
      { path: 'registration-confirm', component: RegistrationConfirmPageComponent },
      { path: 'registration-withpin-confirm', component: RegistrationWithpinConfirmPageComponent },
      { path: 'password-restore', component: PasswordRestorePageComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
